import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ChatConversationLinkAdapter } from 'ias-ppr-mt-chat-client';

@Injectable()
export class AscupChatConversationLinkAdapter implements ChatConversationLinkAdapter {
  private readonly router = inject(Router);

  public getNavigationHref(conversationReference: string): string {
    return this.router.serializeUrl(
      this.router.createUrlTree(['/chat', conversationReference]),
    );
  }
}
